import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { installSession } from "../../authContext";
import { consumeSessionExpired } from "../../utils/sessionExpiry";
import AuthCard, { AuthField } from "./AuthCard";

const SignIn = () => {
    const [user, setUser] = useState({
        email: "",
        password: ""
    });
    const [submitting, setSubmitting] = useState(false);
    // Lu une seule fois, au premier rendu : arriver ici apres une session
    // expiree n'est pas la meme chose qu'y venir de son plein gre, et sans
    // cette phrase l'ejection passe pour une panne.
    const [sessionExpiree] = useState(consumeSessionExpired);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser({ ...user, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const data = {
                email: user.email,
                password: user.password
            };

            const endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/v2/auth/login`;
            const response = await axios.post(endpoint, data);

            if (response.data && response.data.token) {
                installSession(response.data);
            } else {
                toast.error("Email ou mot de passe invalide.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Une erreur est survenue lors de la connexion.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <AuthCard
            title="Me connecter"
            subtitle="Accédez à votre espace BackStageRate."
            footer={
                <>
                    Vous n'avez pas de compte ?{" "}
                    <a href="/signup" className="font-medium text-bsrate underline">
                        Créer mon compte
                    </a>
                </>
            }
        >
            {sessionExpiree && (
                <p
                    role="status"
                    className="mb-4 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
                >
                    Votre session a expiré. Reconnectez-vous pour reprendre où vous en étiez.
                </p>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
                <AuthField
                    id="email"
                    label="Email"
                    type="email"
                    name="email"
                    placeholder="adresse@mail.com"
                    autoComplete="email"
                    required
                    value={user.email}
                    onChange={handleChange}
                />
                <AuthField
                    id="password"
                    label="Mot de passe"
                    type="password"
                    name="password"
                    placeholder="••••••••••"
                    autoComplete="current-password"
                    required
                    value={user.password}
                    onChange={handleChange}
                    hint={
                        <a href="/reset-password" className="text-base-content/60 underline">
                            Mot de passe oublié ?
                        </a>
                    }
                />
                <button type="submit" disabled={submitting} className="btn btn-primary w-full">
                    {submitting ? "Connexion…" : "Me connecter"}
                </button>
            </form>
        </AuthCard>
    );
};

export default SignIn;
